import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    CREATE_SESSION,
    DELETE_TRIAL_LOG,
    DELETE_SESSION,
    EDIT_SESSION,
    EDIT_SESSION_STATUS,
    END_SESSION,
    GET_SESSION_BY_ID,
    GET_SESSION_BY_ID_SUCCESS,
    GET_SESSIONS,
    GET_SESSIONS_SUCCESS,
    PAUSE_SESSION,
    REFRESH_SESSION,
    RESUME_SESSION,
    SAVE_SESSION_TARGET_OPTION,
    SAVE_SESSION_TARGET_OPTION_SUCCESS,
    EDIT_SESSION_GOALS,
    EDIT_SESSION_TIMELINE,
    GET_SESSION_CORRECTIONS,
    GET_SESSION_CORRECTIONS_SUCCESS,
    GET_MANUAL_SESSION_APPTS,
    GET_MANUAL_SESSION_APPTS_SUCCESS,
    GET_MANUAL_SESSION,
    GET_MANUAL_SESSION_SUCCESS,
    SAVE_MANUAL_SESSION,
    GET_MANUAL_MAINTENANCE_CHECKS,
    GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS,
} from './session.types';
import { authService } from './session.service';
import { appointmentService } from '../../appointment/appointment.service';
import { GET_APPOINTMENT_BY_ID_SUCCESS } from '../../appointment/appointment.type';
import { toast } from 'react-toastify';
import { NotError } from '../../../components';
import React from 'react';

/** Sessions */

function* createSession({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const apptSessionData = yield call(authService.createSessionService, payload?.body);
        // const res = yield call(appointmentService.getAppointmentByIdService, payload?.apptId);


        if (apptSessionData?.data?.id && apptSessionData?.data?.appt) {
            window.open(`/appointment/${apptSessionData.data.appt}/session/${apptSessionData.data.id}`, '_blank');
        }

        // const data = {
        //     ...res.data,
        //     cSession: apptSessionData?.data,
        // };
        //
        // console.log(data,'data 11111 res');
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: data,
        // });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getSessions({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSessionsService, payload?.params);
        yield put({
            type: GET_SESSIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getSessionById({ payload, type }) {
    // Guard: skip API call if session ID is missing or not a valid ObjectId
    if (!payload?.id || !/^[0-9a-fA-F]{24}$/.test(payload.id)) return;

    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* resumeSession({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.resumeSessionService, payload?.id);

        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* pauseSession({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.pauseSessionService, payload?.id);

        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* endSession({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.endSessionService, payload?.id);

        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* saveSessionTargetOption({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type, payload?.body));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const session = yield call(authService.saveSessionTargetOptionService, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, session?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put({
            type: SAVE_SESSION_TARGET_OPTION_SUCCESS,
            payload: session?.data,
        });

        const res = yield call(authService.getSessionByIdService, payload?.sessionId);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteDurationLog({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.deleteDurationLogService, payload?.tSummaryId, payload?.trialId);
        const res = yield call(authService.getSessionByIdService, payload?.sessionId);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, payload?.tSummaryId));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* refreshSession({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(authService.refreshSessionService, payload?.sessionId);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

function* editSessionGoalsSaga({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.editSessionGoalsService, payload?.id, payload?.body);
        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editSessionTimelineSaga({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.editSessionTimelineService, payload?.id, payload?.body);
        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_SESSION_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.response?.data));
    }
}

function* getSessionCorrectionsSaga({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSessionCorrectionsService, payload?.id);
        yield put({
            type: GET_SESSION_CORRECTIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Manual session data entry */

function* getManualSessionAppts({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getManualSessionApptsService, payload?.params);
        yield put({
            type: GET_MANUAL_SESSION_APPTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put({ type: GET_MANUAL_SESSION_APPTS_SUCCESS, payload: [] });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getManualMaintenanceChecks({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getManualMaintenanceChecksService, payload?.params);
        yield put({ type: GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put({ type: GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS, payload: [] });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getManualSession({ payload, type }) {
    if (!payload?.id || !/^[0-9a-fA-F]{24}$/.test(payload.id)) return;

    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(authService.getSessionByIdService, payload?.id);
        yield put({
            type: GET_MANUAL_SESSION_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* saveManualSession({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.saveManualSessionService, payload?.body);
        yield put({
            type: GET_MANUAL_SESSION_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, res.data?.id));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        // 409 (appointment already has a live session), 400 (invalid value, future date, inactive
        // goal/target) and 403 all carry a readable message — surface it as-is.
        toast(<NotError type={'error'} errMessage={err?.data?.message || 'Could not save session data.'} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

export const watchSessions = function* watchSessionsAuth() {
    /** Sessions  */
    yield takeLatest(CREATE_SESSION, createSession);
    yield takeLatest(GET_SESSIONS, getSessions);
    yield takeLatest(GET_SESSION_BY_ID, getSessionById);
    yield takeLatest(RESUME_SESSION, resumeSession);
    yield takeLatest(PAUSE_SESSION, pauseSession);
    yield takeLatest(END_SESSION, endSession);
    yield takeLatest(SAVE_SESSION_TARGET_OPTION, saveSessionTargetOption);
    yield takeLatest(DELETE_TRIAL_LOG, deleteDurationLog);
    yield takeLatest(REFRESH_SESSION, refreshSession);
    yield takeLatest(EDIT_SESSION_GOALS, editSessionGoalsSaga);
    yield takeLatest(EDIT_SESSION_TIMELINE, editSessionTimelineSaga);
    yield takeLatest(GET_SESSION_CORRECTIONS, getSessionCorrectionsSaga);
    yield takeLatest(GET_MANUAL_SESSION_APPTS, getManualSessionAppts);
    yield takeLatest(GET_MANUAL_SESSION, getManualSession);
    yield takeLatest(SAVE_MANUAL_SESSION, saveManualSession);
    yield takeLatest(GET_MANUAL_MAINTENANCE_CHECKS, getManualMaintenanceChecks);
    /** End */
};
